import { z } from 'zod';

export const adPopupSchema = z.object({
  id: z.uuid(),
  bubbleId: z.string().min(1).nullable(),
  imageUrl: z.string().min(1),
  link: z.string(),
  activeFrom: z.iso.datetime({ offset: true }).nullable(),
  activeTo: z.iso.datetime({ offset: true }).nullable(),
  isActive: z.boolean(),
  source: z.enum(['bubble', 'postgres']),
  canDelete: z.boolean(),
  confirmedVersion: z.number().int().positive(),
  lastModifiedAt: z.iso.datetime({ offset: true }).nullable(),
});

export const adPopupListResponseSchema = z.object({
  items: z.array(adPopupSchema).max(10),
  pagination: z.object({
    page: z.number().int().positive(),
    pageSize: z.number().int().positive().max(10),
    totalItems: z.number().int().nonnegative(),
    totalPages: z.number().int().nonnegative(),
  }),
});

export const adPopupDetailResponseSchema = z.object({ item: adPopupSchema });
export const adPopupMutationResponseSchema = z.object({
  item: adPopupSchema,
  auditWritten: z.boolean(),
  operationId: z.uuid().nullable(),
});
export const adPopupImageUploadResponseSchema = z.object({
  imageUrl: z.url(),
  mimeType: z.enum(['image/jpeg', 'image/png', 'image/webp']),
  byteSize: z.number().int().positive(),
});
export const currentAdPopupResponseSchema = z.object({
  item: z
    .object({
      id: z.uuid(),
      imageUrl: z.string().min(1),
      link: z.string().min(1),
    })
    .nullable(),
});

export type AdPopup = z.infer<typeof adPopupSchema>;
export type AdPopupListResponse = z.infer<typeof adPopupListResponseSchema>;
export type AdPopupDetailResponse = z.infer<typeof adPopupDetailResponseSchema>;
export type AdPopupMutationResponse = z.infer<typeof adPopupMutationResponseSchema>;
export type AdPopupImageUploadResponse = z.infer<typeof adPopupImageUploadResponseSchema>;
export type CurrentAdPopupResponse = z.infer<typeof currentAdPopupResponseSchema>;
export type CurrentAdPopup = NonNullable<CurrentAdPopupResponse['item']>;
export type AdPopupSurface = 'home_dashboard' | 'payments';
